// CheckingStockBadge - Pulsing placeholder badge shown on search cards
// while the progressive stock-check is still awaiting responses from one
// or more suppliers linked to that master. Resolves to InStockBadge or
// OutOfStockBadge once enough supplier responses have arrived.

export interface CheckingStockBadgeProps {
  className?: string
}

export function CheckingStockBadge({ className = '' }: CheckingStockBadgeProps) {
  return (
    <span
      className={`inline-block whitespace-nowrap text-[11px] bg-amber-50 text-amber-600 px-2 py-0.5 rounded-md font-medium animate-pulse ${className}`}
    >
      Checking stock…
    </span>
  )
}
